import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import Select from 'react-select'

import SuggestedBidTypeSelector from './Shared/SuggestedBidTypeSelector'
import KeywordModal from './Shared/KeywordModal'
import KeywordList from './Shared/KeywordList'
import DefaultBidSection from './Shared/DefaultBidSection'

import { matchTypeOptions } from '../../utils/defaultValues'

const SPKeywordSection = ({ keywords, isSuggestionsLoading, onFind, onChange }) => {
  const suggestedKeywords = useSelector(state => state.campaignCreator.suggestedSPKeywords)

  const [openModal, setOpenModal] = useState(false)
  const [defaultBid, setDefaultBid] = useState(0.75)
  const [defaultMatchType, setDefaultMatchType] = useState(matchTypeOptions[0])

  const handleFind = () => {
    setOpenModal(true)
    onFind()
  }

  const handleSelect = (keywordsToAdd) => {
    setOpenModal(false)

    let newKeywords = [...keywords]
    const keywordsToGetBid = []

    keywordsToAdd.forEach((keyword) => {
      const duplicate = keywords.find(kw => (
        keyword.keywordText === kw.keywordText
          && keyword.matchType === kw.matchType.toLowerCase()
      ))

      if (!duplicate) {
        newKeywords.push({
          keywordText: keyword.keywordText,
          matchType: keyword.matchType,
          keywordBid: defaultBid,
        })

        keywordsToGetBid.push({
          keyword: keyword.keywordText,
          matchType: keyword.matchType,
        })
      }
    })

    newKeywords = newKeywords.map((keyword, index) => ({
      ...keyword,
      id: keyword.id ? keyword.id : index,
    }))

    onChange(newKeywords, true, keywordsToGetBid)
  }

  const handleDefaultMatchTypeApply = () => {
    onChange(keywords.map(item => ({
      ...item,
      matchType: defaultMatchType.value,
    })))
  }

  const renderActions = () => {
    return (
      <div className="field-row">
        <div className="field-wrapper">
          <DefaultBidSection
            targetings={keywords}
            defaultBid={defaultBid}
            forKeyword
            onChange={onChange}
            onDefaultBidChange={setDefaultBid}
          />
        </div>
        <div className="field-wrapper default-match-type-section">
          <label>Default Match Type:</label>
          <Select
            className="match-type-selector"
            options={matchTypeOptions}
            value={defaultMatchType}
            onChange={setDefaultMatchType}
          />
          <button type="button" className="btn btn-blue" onClick={handleDefaultMatchTypeApply}>
            Apply
          </button>
        </div>
        <div className="field-wrapper">
          <SuggestedBidTypeSelector
            targetings={keywords}
            forKeyword
            onChange={onChange}
          />
        </div>
      </div>
    )
  }

  return (
    <div className="section-container">
      <div className="section-title">
        Keywords
        <div>
          <button
            type="button"
            className="btn btn-blue"
            onClick={handleFind}
          >
            Add Keywords
          </button>
        </div>
      </div>
      <div className="section-note">
        Your keywords (word combinations and phrases) are used to match your ads
        with search terms shoppers are using to find products.
      </div>
      { renderActions() }
      <KeywordList
        keywords={keywords}
        defaultBid={defaultBid}
        onChange={onChange}
      />
      <KeywordModal
        show={openModal}
        isLoading={isSuggestionsLoading}
        suggestedKeywords={suggestedKeywords}
        keywordsSelected={keywords}
        onSelect={handleSelect}
        onClose={() => { setOpenModal(false) }}
      />
    </div>
  )
}

export default SPKeywordSection
